import {Injectable} from '@angular/core';

@Injectable()
export class GsbUtils {

  public isDefined(param: any) {
    return param !== null && param !== 'null' && param !== undefined && param !== 'undefined';
  }
}
